import InsertCommentIcon from '@mui/icons-material/InsertComment';
import { useTheme } from '@mui/material';

export const Feedback = () => {
  const theme = useTheme();

  return (
    <InsertCommentIcon
      fontSize="medium"
      sx={{ color: theme.palette.tertiary.main }}
    />
  );
};
